import constants from '../constants';
import getIconDialogCommonTraits from '../helpers/get-icon-dialog-common-traits';
import trackEvent from './track-event';

const { events } = constants;

export default function trackSelectIconDialogSubmitted({
  dialogId,
  targetElementId,
  iconSelected,
  triggerId,
  premiumAvailable,
  tabId,
}) {
  const traits = {
    dialogId,
    ...getIconDialogCommonTraits(targetElementId),
    iconSelected,
    triggerId,
    premiumAvailable,
    tabId,
  };

  trackEvent(events.SELECT_ICON_DIALOG_SUBMITTED, traits);
}
